import { render, staticRenderFns } from "./SideCartMobile.vue?vue&type=template&id=2d242c8e&scoped=true&"
import script from "./SideCartMobile.vue?vue&type=script&lang=js&"
export * from "./SideCartMobile.vue?vue&type=script&lang=js&"
import style0 from "./SideCartMobile.vue?vue&type=style&index=0&id=2d242c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d242c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d242c8e')) {
      api.createRecord('2d242c8e', component.options)
    } else {
      api.reload('2d242c8e', component.options)
    }
    module.hot.accept("./SideCartMobile.vue?vue&type=template&id=2d242c8e&scoped=true&", function () {
      api.rerender('2d242c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/Step2Mobile/SideCartMobile.vue"
export default component.exports